import { render } from "./404.vue?vue&type=template&id=3b17bf6a&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=3b17bf6a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3b17bf6a"

export default script